import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import { Post } from 'components/modules/card/jobPost/jobPost.type';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useFindInternshipPostQuery } from 'service/recruiterQuery/recruiterQuery';
import JobPostList from '../list/JobPostList';

function Internship() {
  const [jobPost, setJobPost] = useState<Post[]>([]);
  const { data, refetch } = useFindInternshipPostQuery('');
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const status = searchParams.get('status') || 'Active';

  const updateJobPost = () => {
    const responseData = data as Post[];
    const filteredData = [];
    for (const item of responseData) {
      if (item.status === status) {
        filteredData.push(item);
      }
    }
    setJobPost(filteredData);
  };

  const handleStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (value === 'Active') {
      searchParams.delete('status');
    } else {
      searchParams.set('status', value);
    }
    navigate(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (Array.isArray(data)) {
      updateJobPost();
    }
  }, [data, status]);
  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between gap-3">
        <div className="ms-xxl-auto d-flex gap-3">
          <SearchBox placeholder="Search by title" />
          <Form.Select
            className="w-auto"
            value={status}
            onChange={handleStatusChange}
          >
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
            <option value="Closed">Closed</option>
          </Form.Select>
        </div>
        <Button
          variant="primary"
          as={Link}
          to="/panel/recruitment/careers/internships/add"
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Add Internship
        </Button>
      </div>
      <div className="mt-4 mb-6">
        <Row>
          <Col xs={12}>
            <JobPostList data={jobPost} type="internship" refetch={refetch} />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Internship;
